import { render } from "./SustainabilityDisplay.vue?vue&type=template&id=3808c49f&scoped=true"
import script from "./SustainabilityDisplay.vue?vue&type=script&lang=js"
export * from "./SustainabilityDisplay.vue?vue&type=script&lang=js"

import "./SustainabilityDisplay.vue?vue&type=style&index=0&id=3808c49f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3808c49f"]])

export default __exports__